var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconDelete = function SvgIconDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11a.5.5 0 0 1-.5-.5V5a.5.5 0 1 1 1 0v5.5a.5.5 0 0 1-.5.5Zm-3 0a.5.5 0 0 1-.5-.5V5a.5.5 0 1 1 1 0v5.5a.5.5 0 0 1-.5.5Zm8-8.5H11v-1C11 .673 10.332 0 9.511 0H4.5C3.673 0 3 .673 3 1.5v1H.5a.5.5 0 1 0 0 1h13a.5.5 0 1 0 0-1ZM4 1.5a.5.5 0 0 1 .5-.5h5.011a.49.49 0 0 1 .489.5v1H4v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 14H3.501c-.827 0-1.5-.673-1.5-1.5V4.992a.5.5 0 0 1 1 0V12.5a.5.5 0 0 0 .5.5h7.001a.5.5 0 0 0 .5-.5V5.013a.5.5 0 1 1 1 0V12.5c0 .827-.673 1.5-1.5 1.5Z"
  }))));
};

export default SvgIconDelete;